import { useMutation } from "@tanstack/react-query";
import * as api from "../request";

export const FULL_USER_COMPANIES_PAYLOAD = {
  include: [
    "associate_companies",
    "associate_companies.locations",
    "associate_companies.locations.state",
    "associate_companies.locations.state.cities",
    "associate_companies.locations.city",
  ],
  filters: {
    is_active_eq: true,
  },
};

// Create category
export function useCreateCategory(onSuccess?: any, onError?: any) {
  const {
    mutate: createCategory,
    error,
    isLoading: creating,
  } = useMutation(
    ["createCategory"],
    async (payload: any) => {
      const { companyId, ...categoryData } = payload;
      return await api.post(`/api/v1/companies/${companyId}/categories`, categoryData);
    },
    {
      onError,
      onSuccess: (response: any) => {
        const data =
          (response && response.status === 200)
            ? response.data
            : (response && response.response && response.response.data);
        onSuccess(data);
      },
    }
  );

  return { createCategory, error, creating };
}

// Status Management Utilities
export const getAllowedStatusTransitions = (currentStatus: string): string[] => {
  switch (currentStatus) {
    case "open":
      return ["in_progress"];
    case "in_progress":
      return ["on_hold", "resolved"];
    case "on_hold":
      return ["in_progress", "resolved"];
    case "resolved":
      return [];
    default:
      return [];
  }
};

export const getStatusLabel = (status: string): string => {
  switch (status) {
    case "open":
      return "Open";
    case "in_progress":
      return "In Progress";
    case "on_hold":
      return "On Hold";
    case "resolved":
      return "Resolved";
    default:
      return status;
  }
};

export const getStatusColorClass = (status: string): string => {
  const statusLower = status.toLowerCase();
  let colorClass = "";

  if (statusLower.includes("open")) {
    colorClass = "open";
  } else if (statusLower.includes("in_progress")) {
    colorClass = "in_progress";
  } else if (statusLower.includes("on_hold")) {
    colorClass = "on_hold";
  } else if (statusLower.includes("resolved")) {
    colorClass = "closed";
  }

  return colorClass;
};

// Date Formatting Utilities
export const formatDateTime = (isoString: string | undefined | null) => {
  if (!isoString) return "-";
  const date = new Date(isoString);
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatIssuedDateTime = (dateString?: string | null) => {
  if (!dateString) return "-";
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateString);
  const date = isDateOnly ? new Date(dateString + "T00:00:00") : new Date(dateString);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour12: true,
  });
};

export const formatDateForInput = (dateString: string) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch {
    return "";
  }
};
